import { AfterViewInit, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalTitleDirective, NzModalFooterDirective, NzModalService, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent, NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { UserService } from 'src/app/private/services/user.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { UserActivityHistoryDto } from 'src/app/shared/dto/user-activity-history.dto';
import _ from 'lodash';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'app-modal-order-process-operators-history',
    standalone: true,
    imports: [
        NzModalTitleDirective,
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        NzModalFooterDirective,
        NzEmptyModule,
        NzIconModule,
        NzToolTipModule,
        NzTableModule,
        FormsModule,
        ReactiveFormsModule,
        LoaderComponent
    ],
    templateUrl: './modal-order-process-operators-history.component.html',
    styleUrl: './modal-order-process-operators-history.component.scss'
})
export class ModalOrderProcessOperatorsHistoryComponent implements OnInit, AfterViewInit {
    @ViewChild('modalContent') private readonly _modalContent!: ElementRef;
    private readonly modalService = inject(NzModalService);
    private readonly toast = inject(NzMessageService);
    private readonly userService = inject(UserService);
    data = inject(NZ_MODAL_DATA);
    orderProcessId!: number;
    isLoading: boolean = true;
    tableHeight!: number;
    processId: number = 0;
    usersActivityHistory: UserActivityHistoryDto[] = [];
    usersActivityHistoryFiltered: UserActivityHistoryDto[] = [];

    async ngOnInit(): Promise<void> {
        this.orderProcessId = this.data?.orderProcessId;
        if (!this.orderProcessId) {
            this.toast.error('No se ha podido cargar el historial de operadores. Por favor, intente nuevamente.');
            return;
        }
        this.usersActivityHistory = await this.userService.getUsersHistoryByOrderProcessId(this.orderProcessId);
        this.usersActivityHistoryFiltered = _.cloneDeep(this.usersActivityHistory);
        this.isLoading = false;
    }

    async ngAfterViewInit(): Promise<void> {
        setTimeout(() => {
            this.tableHeight =
                (this._modalContent.nativeElement as HTMLImageElement)
                    .clientHeight - TITLE_TABLE_SIZE;
        });
    }

    handleCancel(): void {
	    this.modalService.closeAll();
	}

}
